// src/pages/InviteRegistrationPage.js
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

// Базовый URL, чтобы не писать каждый раз
const API_BASE = "http://qcan-dev.smart-era.com:8001/cl/v1";

function InviteRegistrationPage() {
  const navigate = useNavigate();
  const { tokenId } = useParams();

  // Состояния данных из формы
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Состояния для отображения ошибок/сообщений
  const [inviteError, setInviteError] = useState(""); // Ошибка, если токен недействителен
  const [submitError, setSubmitError] = useState(""); // Ошибка при отправке POST
  const [successMsg, setSuccessMsg] = useState("");  // Успех при POST
  const [loading, setLoading] = useState(false);     // Спиннер при загрузке

  // --- Валидация ---
  const isValidName = (val) => val.length >= 2 && val.length <= 50;
  const isValidSurname = (val) => val.length >= 2 && val.length <= 50;
  const isPasswordValid = (val) => /^[A-Za-z0-9]{4,50}$/.test(val);

  // Упрощённая проверка email
  const isEmailValid = (value) => {
    return value.includes("@") && value.length > 4;
  };

  // inline ошибки (можно делать отдельные стейты, но здесь — функции)
  const getNameError = () => {
    if (!name.trim()) return "";
    if (!isValidName(name)) return "Имя должно быть 2..50 символов.";
    return "";
  };
  const getSurnameError = () => {
    if (!surname.trim()) return "";
    if (!isValidSurname(surname)) return "Фамилия должна быть 2..50 символов.";
    return "";
  };
  const getPasswordError = () => {
    if (!password.trim()) return "";
    if (!isPasswordValid(password)) {
      return "Пароль 4..50 символов (латиница/цифры).";
    }
    return "";
  };
  const getConfirmPasswordError = () => {
    if (!confirmPassword.trim()) return "";
    if (confirmPassword !== password) {
      return "Пароли не совпадают.";
    }
    return "";
  };

  // Можно ли нажать «Зарегистрироваться»
  const isFormValid = () => {
    if (inviteError) return false; // Токен невалиден — форма бесполезна
    if (!name.trim() || !surname.trim() || !password.trim() || !confirmPassword.trim()) {
      return false;
    }
    if (getNameError() || getSurnameError() || getPasswordError() || getConfirmPasswordError()) {
      return false;
    }
    // Email должен быть валиден
    if (!isEmailValid(email)) {
      return false;
    }
    return true;
  };

  // ---- 1) useEffect: При монтировании запрашиваем /user/token/{tokenId} ----
  useEffect(() => {
    if (!tokenId) {
      setInviteError("Отсутствует токен приглашения в URL.");
      return;
    }
    setLoading(true);
    setInviteError("");
    setSubmitError("");
    setSuccessMsg("");

    fetch(`${API_BASE}/user/token/${tokenId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        if (!res.ok) {
          // Например, 404 или 400
          const errData = await res.json().catch(() => ({}));
          const errMsg = errData?.message || "Не удалось найти токен пользователя.";
          throw new Error(errMsg);
        }
        return res.json(); // { email: "..." }
      })
      .then((data) => {
        if (!data?.email) {
          throw new Error("Ответ не содержит email.");
        }
        setEmail(data.email);
      })
      .catch((err) => {
        setInviteError(err.message || "Не удалось найти токен пользователя.");
      })
      .finally(() => setLoading(false));
  }, [tokenId]);

  // ---- 2) Сабмит (POST /user/register-by-invitation/{tokenId}) ----
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError("");
    setSuccessMsg("");

    if (!isFormValid()) {
      alert("Исправьте ошибки в форме.");
      return;
    }

    try {
      setLoading(true);
      const body = {
        name,
        surname,
        password,
        passwordConfirmation: confirmPassword,
      };

      const res = await fetch(`${API_BASE}/user/register-by-invitation/${tokenId}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        const errMsg = errData?.message || "Ошибка при регистрации.";
        throw new Error(errMsg);
      }

      // Если всё ОК
      // const result = await res.json(); // { id, name, surname, email }
      // setSuccessMsg("Вы успешно зарегистрированы!"); 
      
      // Вместо или сразу после successMsg — делаем редирект на /login
      navigate("/login");

    } catch (err) {
      setSubmitError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // inline ошибки
  const nameError = getNameError();
  const surnameError = getSurnameError();
  const passwordError = getPasswordError();
  const confirmPasswordError = getConfirmPasswordError();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f0f0f0",
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          background: "#fff",
          padding: "2rem",
          borderRadius: "8px",
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          width: "400px",
        }}
      >
        <h2 style={{ marginBottom: "1.5rem", textAlign: "center" }}>
          Регистрация по приглашению
        </h2>

        {/* Спиннер/загрузка */}
        {loading && (
          <div style={{ textAlign: "center", marginBottom: "1rem" }}>
            <p>Загрузка...</p>
          </div>
        )}

        {/* Ошибка токена (GET) */}
        {inviteError && (
          <div
            style={{
              color: "red",
              fontSize: "0.9rem",
              marginBottom: "1rem",
              textAlign: "center",
            }}
          >
            {inviteError}
          </div>
        )}

        {/* Успех при POST */}
        {successMsg && (
          <div
            style={{
              color: "green",
              fontSize: "0.9rem",
              marginBottom: "1rem",
              textAlign: "center",
            }}
          >
            {successMsg}
          </div>
        )}

        {/* Ошибка при POST */}
        {submitError && (
          <div
            style={{
              color: "red",
              fontSize: "0.9rem",
              marginBottom: "1rem",
              textAlign: "center",
            }}
          >
            {submitError}
          </div>
        )}

        {/* Поле Email (readOnly) */}
        <div className="form-group" style={{ marginBottom: "1rem" }}>
          <label>Email</label>
          <input
            type="email"
            value={email}
            style={{ width: "100%", padding: "0.5rem", backgroundColor: "#ddd" }}
            readOnly
          />
        </div>

        {/* Поле Имя */}
        <div className="form-group" style={{ marginBottom: "1rem" }}>
          <label>Имя</label>
          <input
            type="text"
            placeholder="Введите имя"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ width: "100%", padding: "0.5rem" }}
            disabled={!!inviteError || !!successMsg || loading}
          />
          {nameError && (
            <p style={{ color: "red", fontSize: "0.9rem", marginTop: "0.3rem" }}>
              {nameError}
            </p>
          )}
        </div>

        {/* Поле Фамилия */}
        <div className="form-group" style={{ marginBottom: "1rem" }}>
          <label>Фамилия</label>
          <input
            type="text"
            placeholder="Введите фамилию"
            value={surname}
            onChange={(e) => setSurname(e.target.value)}
            style={{ width: "100%", padding: "0.5rem" }}
            disabled={!!inviteError || !!successMsg || loading}
          />
          {surnameError && (
            <p style={{ color: "red", fontSize: "0.9rem", marginTop: "0.3rem" }}>
              {surnameError}
            </p>
          )}
        </div>

        {/* Поле Пароль */}
        <div className="form-group" style={{ marginBottom: "1rem" }}>
          <label>Пароль</label>
          <div style={{ position: "relative" }}>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Введите пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ width: "100%", padding: "0.5rem", paddingRight: "40px" }}
              disabled={!!inviteError || !!successMsg || loading}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                top: "50%",
                right: "8px",
                transform: "translateY(-50%)",
                background: "transparent",
                border: "none",
                cursor: "pointer",
              }}
            >
              {showPassword ? "Скрыть" : "Показать"}
            </button>
          </div>
          {passwordError && (
            <p style={{ color: "red", fontSize: "0.9rem", marginTop: "0.3rem" }}>
              {passwordError}
            </p>
          )}
        </div>

        {/* Поле Подтверждение */}
        <div className="form-group" style={{ marginBottom: "1rem" }}>
          <label>Подтверждение пароля</label>
          <div style={{ position: "relative" }}>
            <input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Введите пароль ещё раз"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              style={{ width: "100%", padding: "0.5rem", paddingRight: "40px" }}
              disabled={!!inviteError || !!successMsg || loading}
            />
            <button
              type="button"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              style={{
                position: "absolute",
                top: "50%",
                right: "8px",
                transform: "translateY(-50%)",
                background: "transparent",
                border: "none",
                cursor: "pointer",
              }}
            >
              {showConfirmPassword ? "Скрыть" : "Показать"}
            </button>
          </div>
          {confirmPasswordError && (
            <p style={{ color: "red", fontSize: "0.9rem", marginTop: "0.3rem" }}>
              {confirmPasswordError}
            </p>
          )}
        </div>

        {/* Кнопка "Зарегистрироваться" */}
        <button
          type="submit"
          disabled={!isFormValid() || !!successMsg || loading}
          style={{
            width: "100%",
            padding: "0.5rem",
            backgroundColor: isFormValid() ? "#007bff" : "#cccccc",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: isFormValid() ? "pointer" : "not-allowed",
          }}
        >
          Зарегистрироваться
        </button>
      </form>
    </div>
  );
}

export default InviteRegistrationPage;
